import { OverviewTab } from "../../components/dashboard/OverviewTab";

export default function SegmentStep({
  segments = [],
  segmentEdges = [],
  onRefresh,
  businessUrl,
  onOpenSignup,
}) {
  return (
    <OverviewTab
      segments={segments}
      segmentEdges={segmentEdges}
      onRefresh={onRefresh}
      businessUrl={businessUrl}
      isOnboarding={true}
      onActionOverride={onOpenSignup}
    />
  );
}
